import RefreshIcon from "@uui/RefreshCw02";
import UploadIcon from "@uui/Upload01";

import styled from "@mui/material/styles/styled";

import Button, { ButtonProps } from "@rui/Button";
import { StickyContainer, spin } from "@rui/styles";

import { OFFSET_NAV_SPACING } from "../components/MobileNav/styles";

export const RefreshButton = styled(
  ({
    refreshing,
    className,
    ...props
  }: ButtonProps & { refreshing: boolean }) => (
    <Button
      variant="text"
      className={`${className} ${refreshing ? "refreshing" : ""}`}
      startIcon={<RefreshIcon />}
      {...props}
    />
  )
)({
  "& svg": {
    width: "16px",
    height: "16px",
    animation: `${spin} 1s linear infinite`,
    animationPlayState: "paused",
  },
  "&.refreshing svg": {
    animationPlayState: "running",
  },
});

export const UploadButton = styled((props: ButtonProps) => (
  <Button
    startIcon={<UploadIcon sx={{ width: "16px" }} />}
    variant="contained"
    {...props}
  />
))({
  padding: "4px 16px",
});

export const StickyReportsHeader = styled(StickyContainer)(({ theme }) => ({
  bgcolor: "#FFF",
  [theme.breakpoints.down("sm")]: {
    top: `calc(${OFFSET_NAV_SPACING} - 1px)`,
  },
}));
